export interface DateRange {
  minDate: string
  maxDate: string
}

export type DateRangeValidation = 'missing' | 'tooEarly' | 'tooLate' | 'valid'

export function getBookingDateRange(): DateRange {
  const today = new Date()

  const minDate = new Date(Date.UTC(today.getFullYear() - 2, 0, 1))
    .toISOString()
    .split('T')[0]

  const maxDate = new Date(Date.UTC(today.getFullYear() + 2, 11, 31))
    .toISOString()
    .split('T')[0]

  return { minDate, maxDate }
}

export function validateDateInRange(
  value: string | null | undefined,
  range: DateRange,
): DateRangeValidation {
  if (!value)
    return 'missing'
  if (value < range.minDate)
    return 'tooEarly'
  if (value > range.maxDate)
    return 'tooLate'
  return 'valid'
}
